import { useMemo } from "react";
import { useDebounceValue, useWindowSize } from "usehooks-ts";

import { DEVICE_WIDTHS, DEVICES_WIDTHS_DIMENSIONS } from "./constants";

export function useDeviceWidth() {
    const dimensions = useWindowSize();
    const [width] = useDebounceValue(dimensions.width, 100);
    const size = useMemo(() => {
        return DEVICE_WIDTHS.find((deviceWidth) => {
            const [min, max] = DEVICES_WIDTHS_DIMENSIONS[deviceWidth];
            return width >= min && width <= max;
        });
    }, [width]);
    return size || null;
}
